<template>
    <v-form ref="form" v-model="formValid" class="account-user-info-edit">
        <v-card v-bind="$attrs" class="account-user-info-edit__card" outlined>
            <header class="account-user-info-edit__header">
                <div>
                    <span class="account-user-info-edit__eyebrow">PROFILE CONTACT</span>
                    <h3>Edit personal details</h3>
                    <p>Update the information associated with your account.</p>
                </div>
                <v-btn icon aria-label="Cancel editing profile information" @click="cancel">
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
            </header>

            <v-card-text class="account-user-info-edit__fields">
                <v-text-field :value="sub" v-bind="$attrs" label="User ID" disabled />
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field v-model="formInput.firstName" v-bind="$attrs" label="First Name" />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field v-model="formInput.lastName" v-bind="$attrs" label="Last Name" />
                    </v-col>
                </v-row>
                <v-text-field v-model="formInput.company" v-bind="$attrs" label="Company" />
                <v-text-field v-model="formInput.email" v-bind="$attrs" label="Email" :rules="[formRules.email]" />
                <base-tel-input
                    id="phone"
                    ref="phone"
                    v-model="phoneInput"
                    class="tele-input"
                    valid-characters-only
                    :dropdown-options="{
                        showDialCodeInSelection: true,
                        showFlags: true,
                        showDialCodeInList: true,
                        tabindex: 0
                    }"
                    :default-country="userStoredContact.phoneCountryCode"
                    :input-options="{
                        placeholder: 'Phone',
                        maxlength: 25,
                        autocomplete: 'on',
                        name: 'telephone',
                        required: false,
                        autofocus: false,
                        id: '',
                        readonly: false,
                        tabindex: 0,
                        type: 'tel',
                        styleClasses: ''
                    }"
                    @update="assignPhone"
                />
            </v-card-text>
            <footer class="account-user-info-edit__actions">
                <v-btn
                    :block="$vuetify.breakpoint.smAndDown"
                    class="account-user-info-edit__cancel"
                    @click="cancel"
                >
                    Cancel
                </v-btn>
                <v-btn
                    :block="$vuetify.breakpoint.smAndDown"
                    class="account-user-info-edit__save"
                    color="primary"
                    :disabled="!phoneValid || !formValid"
                    @click="save"
                >
                    Save changes
                </v-btn>
            </footer>
        </v-card>
    </v-form>
</template>

<script>
import { mdiClose } from '@mdi/js'
import formRules from '@/utils/form_rules'
export default {
    name: `AccountEditUserInfo`,
    inheritAttrs: false,
    props: {
        userStoredContact: {
            type: Object,
            default: () => {}
        },
        sub: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            mdiClose,
            formRules,
            phone: {},
            phoneInput: ``,
            phoneValid: false,
            formValid: false,
            formInput: {
                company: ``,
                firstName: ``,
                lastName: ``,
                email: ``,
                phone: ``,
                phoneCountryCode: ``
            }
        }
    },
    mounted() {
        this.copyFromStore()
    },
    methods: {
        copyFromStore() {
            this.userStoredContact.firstName && (this.formInput.firstName = this.userStoredContact.firstName)
            this.userStoredContact.lastName && (this.formInput.lastName = this.userStoredContact.lastName)
            this.userStoredContact.email && (this.formInput.email = this.userStoredContact.email)
            this.userStoredContact.company && (this.formInput.company = this.userStoredContact.company)
            this.userStoredContact.phone && (this.phoneInput = this.userStoredContact.phone)
        },

        assignPhone(a) {
            // eslint-disable-next-line no-unused-vars
            const [input, phoneObject] = a
            this.phoneValid = phoneObject.nationalNumber ? !!phoneObject.valid : true
            this.formInput.phone = phoneObject.nationalNumber
            this.formInput.phoneCountryCode = phoneObject.countryCode
        },
        save() {
            if (this.formValid && this.phoneValid)
                this.$emit(`save`, {
                    firstName: this.formInput.firstName,
                    lastName: this.formInput.lastName,
                    email: this.formInput.email,
                    company: this.formInput.company,
                    phone: this.formInput.phone,
                    phoneCountryCode: this.formInput.phoneCountryCode
                })
        },
        cancel() {
            this.$emit(`cancel`)
        }
    }
}
</script>

<style scoped>
.account-user-info-edit {
    min-width: 0;
}
.account-user-info-edit__card {
    overflow: hidden;
    color: #f1f2f5;
    background: rgba(23, 25, 31, 0.38);
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    border-radius: 9px;
    box-shadow: none !important;
}
.account-user-info-edit__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 18px 13px;
    background: linear-gradient(110deg, rgba(219, 81, 32, 0.1), transparent 75%);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.account-user-info-edit__eyebrow {
    color: #f2a58b;
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 1.2px;
}
.account-user-info-edit__header h3 {
    margin: 3px 0 2px;
    color: #f4f5f8;
    font-size: 15px;
    font-weight: 600;
}
.account-user-info-edit__header p {
    margin: 0;
    color: #aeb5c3;
    font-size: 10px;
    line-height: 1.5;
}
.account-user-info-edit__header > .v-btn {
    color: #aeb5c3;
}
.account-user-info-edit__fields {
    padding: 16px 18px 5px;
}
.account-user-info-edit__fields ::v-deep .v-input {
    margin-top: 3px;
}
.account-user-info-edit__fields ::v-deep .v-label {
    color: #aeb5c3;
}
.account-user-info-edit__fields ::v-deep input {
    color: #f1f2f5;
}
.account-user-info-edit__fields ::v-deep .v-input--is-disabled input {
    color: #9299a8;
}
.account-user-info-edit__fields ::v-deep .v-input__slot fieldset {
    border-color: rgba(255, 255, 255, 0.18);
}
.account-user-info-edit__fields ::v-deep .v-input--is-focused .v-label {
    color: #ff9a74;
}
.account-user-info-edit__fields ::v-deep .v-input--is-focused .v-input__slot fieldset {
    border-color: #db5120;
}
.account-user-info-edit__fields ::v-deep .tele-input {
    margin: 4px 0 16px;
}
.account-user-info-edit__fields ::v-deep .vue-tel-input {
    min-height: 40px;
    color: #f1f2f5;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 4px;
}
.account-user-info-edit__fields ::v-deep .vti__input {
    color: #f1f2f5;
    background: transparent;
}
.account-user-info-edit__fields ::v-deep .vti__dropdown {
    color: #c6cbd5;
}
.account-user-info-edit__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 9px;
    padding: 5px 18px 17px;
}
.account-user-info-edit__actions .v-btn {
    min-height: 36px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.2px;
    text-transform: none;
}
.account-user-info-edit__cancel.v-btn {
    color: #c7cbd4;
    border: 1px solid rgba(255, 255, 255, 0.16);
}
.account-user-info-edit__save.v-btn {
    color: #fff;
    background: #db5120;
}
.account-user-info-edit__save.v-btn:hover {
    background: #e76638;
}
@media (max-width: 600px) {
    .account-user-info-edit__actions {
        align-items: stretch;
        flex-direction: column-reverse;
    }
}
</style>
